"use strict";

import Vue from "vue";
import axios from "axios";
axios.defaults.timeout = 2000; // ms
axios.defaults.retry = 4; // count
axios.defaults.retryDelay = 1000; // ms
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    if (location.href.includes("local")) {
      //로컬 서버
      //api 호스트 주소
      // config.baseURL = window.location.protocol+"//localhost:8080"
      config.baseURL = "https://bnb-api.carrotglobal.com";
      // config.baseURL = "http://127.0.0.1:8080";
      // config.baseURL = "https://bnb-stage.carrotglobal.com";
      // config.port = 8081;
    } else if (location.href.includes("stage")) {
      //스테이지 서버
      //api 호스트 주소
      config.baseURL = "https://bnb-stage.carrotglobal.com";
    } else {
      // 운영 서버
      //api 호스트 주소
      // config.baseURL = window.location.protocol+"//master.carrot.com:8081";
      config.baseURL = "https://bnb-api.carrotglobal.com";
    }
    // Do something before request is sent
    //content type : json
    config.headers.put["Content-Type"] = "application/json";

    //axios 타임아웃 1초
    config.timeout = 2000;

    //서버에서 받은 토큰값을 쿠기에 저장을 할시 true, 저장을 안할시에는 false
    // api 호스트 주소와 같은 오리진을 사용할경우 request header 에 쿠기가 자동적으로 생성이 되는데
    // 다른 오리진일경우에는 생성이되지 않습니다, 이떄 이를 해결하기위해 프론트단에서는 withCredentials 을 true로 설정해줍니다
    config.withCredentials = false;

    //토큰 등록
    if (localStorage.getItem("accessToken") && !config.url.includes("kr.object.ncloudstorage.com")) {
      config.headers.common["Authorization"] = "Bearer " + localStorage.getItem("accessToken");
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    console.log("Network Error, Retry");
    var config = error.config;
    const code = error.response.status;
    if (code == 401) {
      alert("자동로그인이 만료되었습니다. 재로그인 해주세요."); // 30일 뒤에 토큰 만료
      localStorage.clear();
      location.href = "/";
      localStorage.setItem("accessToken", false);
      return Promise.reject(error);
    } else {
      // If config does not exist or the retry option is not set, reject
      if (!config || !config.retry) {
        console.log("config.retry Not Exist");
        return Promise.reject(error);
      }

      // Set the variable for keeping track of the retry count
      config.__retryCount = config.__retryCount || 0;

      // Check if we've maxed out the total number of retries
      if (config.__retryCount >= config.retry) {
        // Reject with the error
        console.log("Retry Count Overflow");
        return Promise.reject(error);
      }

      // Increase the retry count
      config.__retryCount += 1;

      // Create new promise to handle exponential backoff
      var backoff = new Promise(function (resolve) {
        console.log("Create New Promise");
        setTimeout(function () {
          resolve();
        }, config.retryDelay);
      });

      // Return the promise in which recalls axios to retry the request
      return backoff.then(function () {
        console.log("Recalls Axios to Retry");
        return _axios(config);
      });
    }
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
